import { z } from 'zod'

export enum PaymentTypeCategory {
  CHARGES_FOR_UTILITIES = 'charges_for_utilities',
  GENERIC = 'generic',
  INTEREST = 'interest',
  RENT = 'rent',
  RESIDENCE_CHARGE = 'residence_charge',
  RIGHT_OF_OCCUPANCY_DEPOSIT = 'right_of_occupancy_deposit',
  RIGHT_OF_OCCUPANCY_NEW_DEVELOPMENT_DEPOSIT = 'right_of_occupancy_new_development_deposit',
  SECURITY_DEPOSIT = 'security_deposit',
}

const bankAccountSchema = z.object({
  iban: z.string(),
  bic: z.string(),
  bankName: z.string(),
})

const paymentCategorySchema = z.object({
  category: z.nativeEnum(PaymentTypeCategory),
  bankAccounts: z.array(bankAccountSchema),
})

export const paymentCategoryListSchema = z.array(paymentCategorySchema)

export type TPaymentCategory = z.infer<typeof paymentCategorySchema>
